<template>
  <div class="company-contacts">
    <div class="table-responsive table-full-width">
      <el-table class="table-striped"
                :data="activeContacts"
                border
                style="width: 100%"
                :max-height="tableHeight(400)">
        <el-table-column
          :render-header="addSwitchAndButton">
          <el-table-column
            label="Name"
            sortable
            :sort-method="(a, b) => callStringSort(a, b, 'firstName')"
            min-width="80">
            <template v-slot="props">
              {{ props.row.firstName }} {{ props.row.lastName }}
            </template>
          </el-table-column>
          <el-table-column
            label="Email(s)"
            min-width="150">
            <template v-slot="props">
              {{ props.row.emails | toCsv }}
            </template>
          </el-table-column>
          <el-table-column
            label="Title"
            min-width="60">
            <template v-slot="props">
              {{ props.row.title }}
            </template>
          </el-table-column>
          <el-table-column
            width="110"
            fixed="right"
            label="Actions">
            <template v-slot="props">
              <p-button type="success" size="sm" icon>
                <i class="fa fa-edit" @click="handleEdit(props.row)"></i>
              </p-button>
              <p-button type="danger" v-if="canEdit" size="sm" icon @click="handleDelete(props.row)">
                <i class="fa fa-times"></i>
              </p-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {getTableHeight, stringSort, notifyWarning} from 'src/utilities/utils'
  import PButton from 'src/components/UIComponents/Button.vue'
  import Permissions from 'src/utilities/permissions'
  import {ptracGet} from '@/utilities/ptracApi'
  import {OK} from 'http-status-codes'

  export default {
    components: {
      PButton
    },
    computed: {
      ...mapGetters({
        contacts: 'companies/companyContacts'
      }),
      canEdit() {
        return this.$can('edit', Permissions.COMPANIES)
      },
      activeContacts() {
        if (this.showInactive) {
          return this.contacts
        }
        return this.contacts.filter(contact => contact.active === true)
      }
    },
    data() {
      return {
        showInactive: false
      }
    },
    methods: {
      callStringSort(a, b, prop) {
        return stringSort(a, b, prop)
      },
      addSwitchAndButton (h, e) {
        if (!this.canEdit) {
          return
        }
        const self = this
        const header = h('h5', {
          style: 'display:inline'
        })
        header.text = 'Contacts'

        // Switch component
        const switchComponent = h('div', {
          class: 'pull-right',
          style: 'margin-right: 12px'
        }, [
          h('label', {style: 'margin-right: 12px; text-transform: capitalize; font-weight: 7;'}, 'Show Inactive'),
          h('p-switch', {
            props: {
              value: self.showInactive,
              type: 'primary',
              onText: 'YES',
              offText: 'NO'
            },

          on: {
              input(value) {
                self.showInactive = value
              }
            }
          })
        ])

        const addButton = h('button', {
          props: {
            type: 'primary'
          },
          class: 'btn btn-fill btn-info pull-right el-icon-edit',
          style: 'padding: 8px',
          on: {
            click (e) {
              self.$eventHub.$emit('show-modal-5', 'Company Contact', null, '800px')
            }
          }
        })

        return [header, addButton, switchComponent]
      },
      handleEdit(contact) {
        this.$eventHub.$emit('show-modal-5', 'Company Contact', contact, '1000px')
      },
      async handleDelete(row) {
        const response = await ptracGet('companies/jobExistsByClientOrBuilderContact?id=' + row.id)

        if (OK === response.status && response.data === true) {
          notifyWarning(this, `${row.name} is associated with an existing Job. Please deactive the contact instead.`)
          return
        }

        this.$store.commit('companies/companyContactRemove', row)
      },
      tableHeight(buffer) {
        return getTableHeight(buffer)
      }
    }
  }
</script>

<style scoped>
  .company-contacts {
    width: 100%;
  }
</style>
